module.exports = __webpack_public_path__ + "images/bannerPT-f794416ae3b27dab2020df1ee71ae68e.png";